import React from 'react'

const Error = () => {
  return (
    <div className='flex justify-center mt-11 items-center font-inter font-bold text-4xl text-richblack-5 '>
        Error - 404 Not Found
    </div>
  )
}

export default Error